module.exports = __webpack_public_path__ + "static/img/8.b0849ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/8/zh/8.png
// module id = cmlp
// module chunks = 0